import React, { Fragment } from "react";
import Navbar3 from "../../components/Navbar3/Navbar3";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import IndustryChallenges from "../../components/IndustryChallenges/IndustryChallenges";
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import CaseStudyCard from "../../components/CaseStudyCard/CaseStudyCard";
import SoftwareFeatures from "../../components/SoftwareFeatures/SoftwareFeatures";
import FeaturedBlogs from "../../components/FeaturedBlogs/FeaturedBlogs";
import RealEstateBusiness from "../../components/RealEstateBusiness/RealEstateBusiness";
import Footer from "../../components/footer/Footer";
import IconCard1 from "../../images/icon_card_9.png";
import IconCard2 from "../../images/icon_card_7.png";
import IconCard3 from "../../images/icon_card_8.png";
import IconCard4 from "../../images/icon_card_6.png";
import imageEcom from "../../images/img_ecom.png";

const ProjectPageS4 = () => {
  const solutions = [
    {
      title: "Struggling with Outdated IT Infrastructure & Scalability?",
      problem:
        "Legacy systems, slow performance, and lack of cloud integration.",
      solution:
        "We develop cloud-based IT solutions, scalable architectures, and robust security frameworks to modernize your infrastructure and enhance operational efficiency.",
    },
    {
      title: "Need Better Cybersecurity & Data Protection?",
      problem:
        "Rising cyber threats, data breaches, and compliance risks day by day.",
      solution:
        "We implement advanced cybersecurity measures, encryption protocols, and regulatory compliance solutions to safeguard sensitive data and protect IT assets.",
    },
    {
      title: "Struggling to Attract & Convert Clients Online?",
      problem:
        "Poor search rankings, low engagement, and ineffective marketing.",
      solution:
        "Our SEO-driven strategies, PPC campaigns, and targeted content marketing help IT companies enhance visibility and generate high-quality leads.",
    },
  ];

  const services = [
    {
      title: "Web Development",
      description: [
        "Scalable, high-performance IT websites & SaaS platforms",
        "Cloud-based software development & API integrations",
        "AI-powered chatbots & automation solutions",
        "Cybersecurity-enhanced IT portals & dashboards",
        "Custom CRM & ERP development for IT enterprises",
      ],
      image: require("../../images/web-development-2.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
    {
      title: "Digital Marketing",
      description: [
        "SEO & content marketing to boost search rankings",
        "PPC & paid advertising for lead generation",
        "Email automation & nurturing campaigns for IT solutions",
        "Social media management & thought leadership positioning",
        "Reputation management & online credibility building",
      ],
      image: require("../../images/digital-marketing-2.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
  ];

  const features = [
    { title: "Cloud Migration & Infrastructure Analytics", icon: IconCard1 },
    {
      title: "Cybersecurity Monitoring & Compliance Reportst",
      icon: IconCard2,
    },
    { title: "IT SaaS Platform UI/UX Mockups", icon: IconCard3 },
    { title: "Automated AI-Powered IT Solutions", icon: IconCard4 },
  ];

  const caseStudyData = {
    sectionTitle: "Real Results for the world of IT",
    sectionSubtitle:
      "Our AI-driven IT platform increased lead conversions by 75% within 6 months!",
    image: require("../../images/cart/cart.png"),
    imageAlt: "E-commerce Case Study",
    title: "Establishment of an Ecom",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    buttonText: "Read More",
    viewMoreText: "View More Case Studies ➜",
  };

  const realEstateData = {
    title: "Let’s Transform Your IT Business",
    description:
      "Harness the power of digital transformation and secure your competitive edge in the IT industry.",
    buttonText: "Schedule a Strategy Call Today",
    image: require("../../images/it.png"),
  };

  const blogs = [
    {
      id: 1,
      title: "Establishment of an Ecom",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: imageEcom,
    },
    {
      id: 2,
      title: "We Setup a Mark to Identity",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work-1.png",
    },
    {
      id: 3,
      title: "Digitalization",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work.png",
    },
  ];

  const header =
    "Stay ahead of the latest trends in IT innovation, security, and digital transformation.";

  return (
    <Fragment>
      <div
        style={{
          backgroundImage: `url('/img/solutionbg.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
        <Navbar3 topbarNone={"wpo-header-style-6"} />
        <PageTitle
          pageTitle={"Innovative IT Solutions for a Digital-First World"}
          pageSub={
            "Scalable, secure, and future-ready digital solutions to help IT businesses drive efficiency, optimize performance, and stay ahead in a competitive market."
          }
          backgroundImage={require("../../images/web-5.png")}
          buttonText={"Get a free consultation"}
        />
        <IndustryChallenges solutions={solutions} />
        <ServiceCard services={services} />
        {/* <CaseStudyCard caseStudy={caseStudyData} /> */}
        <SoftwareFeatures
          features={features}
          title={"Bringing Innovation to IT"}
          subTiltle={"When you team up with us for web development, you get"}
        />
        {/* <FeaturedBlogs blogs={blogs} header={header} /> */}
        <RealEstateBusiness
          title={realEstateData.title}
          description={realEstateData.description}
          buttonText={realEstateData.buttonText}
          image={realEstateData.image}
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          boxAlign="center"
          titleColor="#fff"
          descriptionColor="#fff"
        />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ProjectPageS4;
